<script>
export default {
  name: 'login',
  data () {
    return {}
  },
  async created () {
    if (this.$route.query && Object.keys(this.$route.query).length) {
      let params = this.$route.query
      if (!this.$route.query.token) return this.toHome()
      const {data: result} = await this.$http.get(`/mini/sso/login?token=${this.$route.query.token}`)
      if (result.code !== 200) return this.toHome()
      this.$store.commit('setUser', result.data)
      if (!params.redirectUri) return this.toHome()
      if (params.redirectUri === 'home') return this.toHome()
      if (params.redirectUri === 'hotels' && params.cityCode && params.checkIn && params.checkOut) return this.toHotelList(params)
      if (params.redirectUri === 'order') return this.toOrderList(params)
    } else {
      this.toHome()
    }
  },
  methods: {
    toHome () {
      this.$router.push('/NewHome/HomeSearch')
    },
    async toHotelList (params) {
      let headers = {accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''}
      const {data: result} = await this.$http.get(`/mini/getCityDistrict?cityCode=${params.cityCode}`, {headers})
      if (result.code !== 200) return this.toHome()
      let obj = {
        room: 1,
        adult: 2,
        checkDates: [params.checkIn, params.checkOut],
        checkIn: params.checkIn,
        checkOut: params.checkOut,
        keyword: result.data.cityNameCN,
        name: result.data.cityNameCN,
        cityCode: params.cityCode,
        cityInfo: {},
        regionId: params.cityCode.indexOf('KK') !== -1 ? 2 : 1,
        cityType: true
      }
      sessionStorage.setItem('regionId', obj.regionId)
      sessionStorage.setItem('homeSearchForm', JSON.stringify(obj))
      this.$router.replace('/HotelList')
    },
    toOrderList (params) {
      this.$router.replace({
        path: '/orderManage',
        query: {
          clientReference: params.clientReference
        }
      })
    }
  }
}
</script>

<template>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/sso/login.vue